import { useState } from "react";
import type { QuickReply } from "@/pages/messages/quickReplies";

interface QuickRepliesProps {
  replies: QuickReply[];
  onPick: (text: string) => void;
}

/**
 * Fila de mensajes predefinidos (respuestas rápidas) para agilizar el chat.
 * Se puede plegar y desplaza horizontalmente en pantallas angostas.
 */
export default function QuickReplies({ replies, onPick }: QuickRepliesProps) {
  const [open, setOpen] = useState(true);

  if (replies.length === 0) return null;

  return (
    <div className="mb-2">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        className="flex cursor-pointer items-center gap-1.5 rounded-md px-1 py-0.5 text-xs font-semibold text-foreground-600 transition-colors hover:text-primary-600"
      >
        <i className="ri-magic-line text-sm text-primary-500"></i>
        Respuestas rápidas
        <i
          className={`text-sm transition-transform ${
            open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
          }`}
        ></i>
      </button>

      {open && (
        <div className="no-scrollbar mt-2 flex gap-2 overflow-x-auto pb-1">
          {replies.map((reply) => (
            <button
              key={reply.id}
              type="button"
              onClick={() => onPick(reply.text)}
              className="flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
            >
              <i className={`${reply.icon} text-sm`}></i>
              {reply.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}